
import { Grid, List, BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ViewMode } from '@/pages/Directory';

interface DirectoryHeaderProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  resultsCount: number;
}

export const DirectoryHeader = ({ 
  viewMode, 
  onViewModeChange, 
  resultsCount 
}: DirectoryHeaderProps) => {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-3xl font-bold">Certified Products Directory</h1>
        <p className="text-muted-foreground mt-2">
          Discover certified products from our network
        </p>
        <Badge variant="secondary" className="mt-2">
          {resultsCount} certified products
        </Badge>
      </div>
      
      <div className="flex items-center gap-2">
        <div className="flex items-center border rounded-md">
          <Button
            variant={viewMode === 'card' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('card')}
            className="rounded-r-none border-r-0"
          >
            <Grid className="h-4 w-4" />
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            className="rounded-none border-r-0"
          >
            <List className="h-4 w-4" />
          </Button>
          <Button
            variant={viewMode === 'benchmark' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('benchmark')}
            className="rounded-l-none"
          >
            <BarChart3 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
